import { Injectable } from '@angular/core';
import {
  FieldAgentClient, BranchAccessLevel, BinLocationsRequest,
  Branch, BinLocationsRequestHowToApply, BinLocations
} from 'ep-bt-field-agent-proxy';
import { BistrackConfig, PageNames } from 'ep-bt-controls';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaProductBinlocationService {

  // This will be used when product is selected and come back to wizard

  public wizardStep = 0;

  // This will be used when selected from binlocation grid and used for update of bins
  public selectedBinLocation: BinLocations;

  // Not filtered bins
  // public nonfiltredBins: any[] = [];

  // List of products used for binlocation products
  public selectedProducts: any[] = [];

  // List bin
  public binLocations: any;

  // Validation flag bin location tab
  public binLocationFormFlag = false;

  // Selected branch from bin location tab
  public selectedBranchId: number;

  // Selected branch from bin location tab
  public selectedBranch: any;

  // from dashboard or product details flag
  public fromDashbard = false;

  public fromPageToBins: string = PageNames.ProductSearch;

  // Summary Related properties
  public selectedRadioButton = '';
  public selectedProductsForBinding: any[] = [];
  public result: any[] = [];
  public successCount = 0;
  public errorMessage = '';

  constructor(private client: FieldAgentClient, private config: BistrackConfig) { }

  getBinLocations(productID: number, userID: number, branchAccessLevel: BranchAccessLevel,
    subscribe: (binLocations: any) => void) {
    this.client.getBinLocations(productID, userID, branchAccessLevel).subscribe(binLocationsRes => {
      this.binLocations = binLocationsRes;
      subscribe(binLocationsRes);
    });
  }

  prepareData(flag: boolean) {
    this.selectedProductsForBinding = [];
    this.selectedProducts.forEach(product => {
      this.selectedProductsForBinding.push({
        productId: product.productId,
        productCode: product.productCode,
        description: product.description,
        standardSellPrice: product.standardSellPrice,
        stockAvailable: product.stockAvailable,
        binLocations: product.binLocations,
        stockPerCode: product.stockPerCode,
        // binLocationsAfter: flag ? this.selectedBinLocation.bins.join(',') : ''
        binLocationsAfter: this.prepareBinLocations(flag, product.binLocations)
      });
    });
  }

  prepareBinLocations(flag: boolean, beforeBins: string): string {
    let finalBins = '';
    if (flag) {
      if (this.selectedRadioButton == 'Add') {
        let bins = beforeBins.split(',');
        if (beforeBins.trim() != '') {
          bins = [...bins, ...this.selectedBinLocation.bins];
        } else {
          bins = this.selectedBinLocation.bins;
        }
        const distinctBins = Array.from(new Set(bins.map((item: any) => item.trim())));
        finalBins = distinctBins.join(',');
        return finalBins;
      } else if (this.selectedRadioButton == 'Replace') {
        return finalBins + this.selectedBinLocation.bins.join(',');
      } else if (this.selectedRadioButton == 'Remove') {
        const bins = beforeBins.split(',');
        const distinctBins = Array.from(new Set(bins.map((item: any) => item.trim())));

        this.selectedBinLocation.bins.forEach(item => {
          const index = distinctBins.indexOf(item.trim());
          if (index >= 0) {
            distinctBins.splice(index, 1);
          }
        });

        // var selBins: string[] = this.selectedBinLocation.bins;
        // var res = bins.filter(f => !selBins.includes(f));
        // var distinctBins = Array.from(new Set(bins.map((item: any) => item.trim())));
        finalBins = distinctBins.join(',');
        return finalBins;
      }

      return finalBins;
    } else {
      return finalBins;
    }
  }

  saveBinLocations(subscribe: (result: any) => void) {
    const request = new BinLocationsRequest();
    request.branch = this.selectedBranch;
    request.bins = this.selectedBinLocation.bins;
    request.products = this.selectedProducts;
    if (this.selectedRadioButton == 'Add') {
      request.howToApply = BinLocationsRequestHowToApply.Add;
    } else if (this.selectedRadioButton == 'Remove') {
      request.howToApply = BinLocationsRequestHowToApply.Remove;
    } else if (this.selectedRadioButton == 'Replace') {
      request.howToApply = BinLocationsRequestHowToApply.Replace;
    } else {
      request.howToApply = BinLocationsRequestHowToApply.Undefined;
    }

    this.client.setBinLocations(this.config.getLoggedinUser(), request).subscribe(result => {
      subscribe(result);
    });
  }

  clearData(frompage: string = PageNames.ProductSearch) {
    this.selectedBinLocation = null;
    this.selectedProducts = [];
    this.binLocations = null;
    this.binLocationFormFlag = false;
    this.selectedBranchId = null;
    this.selectedBranch = null;
    this.selectedRadioButton = '';
    this.selectedProductsForBinding = [];
    this.errorMessage = '';
    this.wizardStep = 0;
    this.fromDashbard = false;
    this.fromPageToBins = frompage;
    // this.nonfiltredBins = [];
  }
}
